/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_Create_Owner_FirstInputs */

const cs_franchise_create_owner_first = /** @type {(inputs: Franchise_Create_Owner_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno majitele`)
};

const en_franchise_create_owner_first = /** @type {(inputs: Franchise_Create_Owner_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner first name`)
};

/**
* | output |
* | --- |
* | "Owner first name" |
*
* @param {Franchise_Create_Owner_FirstInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_create_owner_first = /** @type {((inputs?: Franchise_Create_Owner_FirstInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_Create_Owner_FirstInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_create_owner_first(inputs)
	return cs_franchise_create_owner_first(inputs)
});